import styled from "styled-components";
import styledMap from "styled-map";
import { maxWidth, space } from "styled-system";
import { transparentize } from "polished";

import theme from "config/theme";

import StyledLoader from "components/Loader";

export const Wrapper = styled.form`
  width: 100%;

  ${maxWidth};
  ${space};
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  background-color: white;
  transition: ${theme.transition};
  border-radius: ${theme.radius};
  box-shadow: 0 1px 3px 0 ${transparentize(0.9, theme.color.gray)},
    0 4px 9px 0 ${transparentize(0.95, theme.color.gray)};

  padding-right: ${styledMap("size", {
    small: "8px",
    default: "10px"
  })};
`;

export const Input = styled.input`
  flex: 1;
  padding: 20px;
  border: none;
  text-overflow: ellipsis;
  border-radius: ${theme.radius};
  color: ${theme.color.gray2};

  padding: ${styledMap("size", {
    small: "15px",
    default: "20px"
  })};

  font-size: ${styledMap("size", {
    small: theme.font.size.zeta,
    default: theme.font.size.delta
  })};

  @media (max-width: ${theme.size.mobile}) {
    font-size: ${styledMap("size", {
      small: theme.font.size.zeta,
      default: theme.font.size.epsilon
    })};
  }

  &:focus,
  &:active {
    outline: none;
    color: ${theme.color.gray};

    &::placeholder {
      color: ${theme.color.gray3};
    }
  }

  &::placeholder {
    transition: ${theme.transition};
    color: ${transparentize(0.3, theme.color.gray3)};
  }
`;

export const Status = styled.span`
  display: block;
  margin-top: 12px;
  text-align: center;
  line-height: 1.3;
  font-size: ${theme.font.size.kappa};

  color: ${styledMap("status", {
    error: theme.color.red,
    default: theme.color.blue
  })};

  a {
    font-weight: ${theme.font.weight.bold};

    color: ${styledMap("status", {
      error: theme.color.red,
      default: theme.color.blue
    })};

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const Loader = styled(StyledLoader)``;
